"use client";
import { usePathname } from "next/navigation";
import React, { useEffect, useState } from "react";
import LoginModal from "../modal/LoginModal";
import RequestCallbackModal from "../modal/RequestCallbackModal";

export default function UpdatePageKey({
  pageKey,
}: {
  pageKey: string | null | undefined;
}) {
  const [pageKeyChange, setPageKeyChange] = useState(pageKey ?? "default");
  const pathname = usePathname();

  useEffect(() => {
    if (pathname.startsWith("/mutual-fund/") && /\/mso\d+$/i.test(pathname)) {
      setPageKeyChange("scheme-detail");
    } else if (
      pathname.startsWith("/tools-and-calculators") ||
      pathname.endsWith("-sip-calculator")
    ) {
      setPageKeyChange("tools-and-calculators");
    } else if (pathname.startsWith("/financial-planning/retirement-planning")) {
      setPageKeyChange("retirement");
    } else if (pathname.startsWith("/buy-digital-gold")) {
      setPageKeyChange("digital-gold");
    } else if (pathname.startsWith("/mutual-fund/portfolio-overlap")) {
      setPageKeyChange("overlap");
    } else if (pathname.startsWith("/mutual-fund/compare")) {
      setPageKeyChange("compare-funds");
    } else if (pathname.startsWith("/portfolio-services")) {
      setPageKeyChange("portfolio-services");
    } else if (pathname.startsWith("/client-assessment")) {
      setPageKeyChange("assessment");
    } else if (pathname === "/sif") {
      setPageKeyChange("sif");
    } else if (pathname === "/login") {
      setPageKeyChange("login-page");
    } else if (pathname === "/") {
      setPageKeyChange("homePage");
    }
  }, [pathname]);

  return (
    <>
      <LoginModal pageKey={pageKeyChange} />
      <RequestCallbackModal pageKey={pageKeyChange} />
    </>
  );
}
